import * as React from 'react';
import { useState, useEffect, useRef } from 'react';

interface Props {
  focusAtStart?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
}

export const OverlaySearch: React.FunctionComponent<Props> = props => {
  const inputEl = useRef<HTMLInputElement>(null);
  const [query, setQuery] = useState<string>('');

  if (props.focusAtStart) {
    useEffect(() => {
      if (inputEl.current) {
        inputEl.current.focus();
      }
    }, []);
  }

  useEffect(() => {
    if (inputEl.current) {
      inputEl.current.focus();
    }
  }, [query]);

  const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    if (event.keyCode === 13) {
      if (props.onSubmit) {
        props.onSubmit(value);
      }
      event.preventDefault();
    }
  };

  const didChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  return (
    <div className="overlay-search">
      <input
        ref={inputEl}
        className="overlay-search-input"
        type="search"
        value={query}
        onKeyUp={onKeyUp}
        onChange={didChange}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/OverlaySearch.tsx